// extracted by mini-css-extract-plugin
export default {"stack":"ParallelRideWithCushionStep_stack__MFeKL"};